import filtersActions from './filters'

export default {
  ...filtersActions,
}
